import I from "@babel/runtime/helpers/esm/classCallCheck";
import k from "@babel/runtime/helpers/esm/createClass";
import u from "@babel/runtime/helpers/esm/assertThisInitialized";
import x from "@babel/runtime/helpers/esm/inherits";
import b from "@babel/runtime/helpers/esm/createSuper";
import c from "@babel/runtime/helpers/esm/defineProperty";
import f from "react";
import { Component as y } from "@semcore/core";
import R from "@semcore/utils/lib/uniqueID";
import A from "@semcore/utils/lib/enhances/i18nEnhance";
import { localizedMessages as w } from "./translations/__intergalactic-dynamic-locales.mjs";
import { isFocusInside as p, setFocus as m } from "@semcore/utils/lib/use/useFocusLock";
import T from "@semcore/utils/lib/enhances/focusSourceEnhance";
import { getAccessibleName as _ } from "@semcore/utils/lib/getAccessibleName";
var F = [R(), A(w), T()], G = /* @__PURE__ */ f.createContext(0), V = /* @__PURE__ */ function(P) {
  x(g, P);
  var v = b(g);
  function g() {
    var t;
    I(this, g);
    for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++)
      i[r] = arguments[r];
    return t = v.call.apply(v, [this].concat(i)), c(u(t), "role", void 0), c(u(t), "popperRef", /* @__PURE__ */ f.createRef()), c(u(t), "triggerRef", /* @__PURE__ */ f.createRef()), c(u(t), "menuRef", /* @__PURE__ */ f.createRef()), c(u(t), "itemProps", []), c(u(t), "itemRefs", []), c(u(t), "highlightedItemRef", /* @__PURE__ */ f.createRef()), c(u(t), "prevHighlightedIndex", null), c(u(t), "handleClickTrigger", function(s) {
      var o = t.asProps, n = o.interaction, l = o.inlineActions;
      if (n === "none" || l) return !1;
      setTimeout(function() {
        var a = t.asProps, h = a.visible, d = a.inlineActions;
        (h || d) && t.afterOpenPopper();
      }, 200);
    }), c(u(t), "afterOpenPopper", function() {
      var s, o = (s = t.asProps.highlightedIndex) !== null && s !== void 0 ? s : 0, n = t.itemRefs[o];
      n == null || n.focus(), t.role === "menu" && t.handlers.highlightedIndex(o);
    }), t;
  }
  return k(g, [{
    key: "uncontrolledProps",
    value: function() {
      var e = this;
      return {
        selectedIndex: null,
        highlightedIndex: [null, function(i) {
          e.handlers.selectedIndex(i);
        }],
        visible: null
      };
    }
  }, {
    key: "childRole",
    get: function() {
      if (this.role === "listbox")
        return "option";
      var e = this.asProps, i = e.selectable, r = e.multiselect;
      return r ? "menuitemcheckbox" : i ? "menuitemradio" : "menuitem";
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var e = this.asProps, i = e.size, r = e.uid, s = e.disablePortal, o = e.visible, n = e.getI18nText;
      return {
        size: i,
        id: "igc-".concat(r, "-trigger"),
        focusHint: o && !s ? n("triggerHint") : void 0,
        "aria-haspopup": "true",
        "aria-expanded": o ? "true" : "false",
        onClick: this.handleClickTrigger,
        ref: this.triggerRef
      };
    }
  }, {
    key: "getListProps",
    value: function() {
      return this.getBasicListProps();
    }
  }, {
    key: "getMenuProps",
    value: function() {
      return this.getBasicListProps();
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var e = this.asProps, i = e.uid, r = e.disablePortal, s = e.ignorePortalsStacking, o = e.interaction, n = e.highlightedIndex;
      return {
        ref: this.popperRef,
        tabIndex: -1,
        id: "igc-".concat(i, "-popper"),
        disablePortal: r,
        ignorePortalsStacking: s,
        focusMaster: o === "click",
        hideFocus: n !== null,
        "use:autoFocus": !1
      };
    }
  }, {
    key: "getGroupProps",
    value: function() {
      var e = this.asProps.size;
      return {
        size: e
      };
    }
  }, {
    key: "getItemProps",
    value: function(e, i) {
      var r = this, s = this.asProps, o = s.size, n = s.uid, l = this.childRole;
      return {
        id: "igc-".concat(n, "-option-").concat(i),
        size: o,
        index: i,
        onMouseEnter: function() {
          r.handlers.selectedIndex(i);
        },
        role: l,
        isMenuItemCheckbox: l === "menuitemcheckbox",
        "aria-checked": l === "menuitemcheckbox" || l === "menuitemradio" ? !1 : void 0
      };
    }
  }, {
    key: "getItemHintProps",
    value: function() {
      var e = this.asProps.size;
      return {
        size: e
      };
    }
  }, {
    key: "getItemTitleProps",
    value: function() {
      var e = this.asProps.size;
      return {
        size: e
      };
    }
  }, {
    key: "scrollToNode",
    value: function(e) {
      var i = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      e && (this.highlightedItemRef.current = e), setTimeout(function() {
        e != null && e.scrollIntoView && i.asProps.highlightedIndex !== i.prevHighlightedIndex && (i.prevHighlightedIndex = i.asProps.highlightedIndex, e.scrollIntoView({
          block: "nearest",
          inline: "nearest",
          behavior: r ? "smooth" : "instant"
        }));
      }, 0);
    }
  }, {
    key: "getHighlightedIndex",
    value: function(e) {
      var i, r = this.asProps, s = r.highlightedIndex, o = r.itemsCount, n = (o ?? this.itemProps.length) - 1, l = this.itemProps.findIndex(function(d) {
        return d == null ? void 0 : d.selected;
      });
      if (n < 0) return -1;
      var a;
      s == null ? l !== -1 ? a = l : this.highlightedItemRef.current && this.prevHighlightedIndex !== null ? a = this.prevHighlightedIndex > n ? n : this.prevHighlightedIndex : a = e < 0 ? 0 : n : a = s > n ? n : s;
      var h = a + e;
      return h < 0 ? h = e + n + 1 : h > n && (h = h - n - 1), (i = this.itemProps[h]) !== null && i !== void 0 && i.disabled ? this.getHighlightedIndex(e < 0 ? e - 1 : e + 1) : this.itemProps[h] ? h : -1;
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      var i = this.asProps, r = i.visible, s = i.focusSourceRef, o = r !== e.visible;
      o && !r && e.visible !== void 0 && (this.handlers.highlightedIndex(null), this.prevHighlightedIndex = null, this.highlightedItemRef.current = null, this.popperRef.current && this.triggerRef.current && (document.activeElement === document.body || p(this.popperRef.current)) && s.current === "keyboard" && m(this.triggerRef.current));
    }
  }, {
    key: "itemRef",
    value: function(e, i, r) {
      var s;
      r != null && (s = r.getAttribute("role")) !== null && s !== void 0 && s.startsWith(this.childRole) && (this.itemRefs[i] = r, this.itemProps[i] = e);
    }
  }, {
    key: "handlePreventCommonKeyDown",
    value: function(e) {
      if (e.target instanceof Element) {
        var i = e.target.tagName;
        if (e.key === " " && ["INPUT", "TEXTAREA"].includes(i) || e.key === "Enter" && i === "TEXTAREA") return !1;
      }
    }
  }, {
    key: "handlePreventPopperKeyDown",
    value: function(e) {
      if (e.target instanceof Element) {
        var i = e.target.tagName;
        if ((e.key === " " || e.key === "Enter") && (i === "BUTTON" || i === "A")) return !1;
      }
    }
  }, {
    key: "handleOpenKeyDown",
    value: function(e) {
      var i;
      this.asProps.visible !== !0 && ["ArrowDown", "ArrowUp", "Enter", " "].includes(e.key) && !((i = e.currentTarget.getAttribute("role")) !== null && i !== void 0 && i.startsWith(this.childRole)) && (["ArrowDown", "ArrowUp"].includes(e.key) && this.handlers.visible(!0), this.handleClickTrigger(e));
    }
  }, {
    key: "handleArrowKeyDown",
    value: function(e) {
      var i = e.shiftKey ? 5 : 1, r = this.asProps, s = r.highlightedIndex, o = r.inlineActions, n = null;
      switch (e.key) {
        case "ArrowDown": {
          o || (n = i);
          break;
        }
        case "ArrowUp": {
          o || (n = -i);
          break;
        }
        case "ArrowRight": {
          o && (n = i);
          break;
        }
        case "ArrowLeft": {
          o && (n = -i);
          break;
        }
        case " ":
        case "Enter":
          this.highlightedItemRef.current && s !== null && !this.itemProps[s].disabled && (e.stopPropagation(), e.preventDefault(), this.highlightedItemRef.current.click());
          break;
      }
      if (n !== null) {
        var l = this.getHighlightedIndex(n);
        if (this.role === "listbox" && this.triggerRef.current && !p(this.triggerRef.current) && this.focusTrigger(), l !== -1 && (this.handlers.highlightedIndex(l, e), this.role === "menu")) {
          var a;
          (a = this.itemRefs[l]) === null || a === void 0 || a.focus();
        }
        e.preventDefault(), e.stopPropagation();
      }
    }
  }, {
    key: "focusTrigger",
    value: function() {
      var e = this.triggerRef.current;
      e && (p(e) || m(e));
    }
  }, {
    key: "getBasicListProps",
    value: function() {
      var e, i = this.asProps, r = i.size, s = i.uid, o = (e = this.triggerRef.current) === null || e === void 0 ? void 0 : e.id, n = o ? document.getElementById(o) : null;
      return {
        size: r,
        index: this.asProps.highlightedIndex,
        tabIndex: -1,
        ref: this.menuRef,
        id: "igc-".concat(s, "-list"),
        role: this.role,
        "aria-label": _(n)
      };
    }
  }]), g;
}(y);
export {
  V as AbstractDropdown,
  F as enhance,
  G as selectedIndexContext
};
